module.exports = __webpack_public_path__ + "media/images/flags/ag-78b358f3aa6e332355f900d133d3eff4.svg";